export default __webpack_public_path__ + "static/media/Map4-1.dfaa4e05.png";